// src/pages/Confidentialite.js
import React from "react";
import "../index.css";
import useSEO from "../seo/useSEO";

export default function Confidentialite() {
  useSEO({
    title: "Politique de confidentialité — HLBK",
    description:
      "Politique de confidentialité du site HLBK (hlbk.fr) : données personnelles, cookies, mesures d’audience et droits RGPD.",
    canonical: "/confidentialite",
    image: "/images/og-default.jpg",
  });

  return (
    <section className="legal-page">
      <header className="legal-hero">
        <h1>Politique de confidentialité</h1>
        <p>Données personnelles, cookies, mesure d’audience et droits RGPD</p>
      </header>

      <article className="legal-card">
        <h2>1 — Introduction</h2>
        <p>
          La présente politique de confidentialité a pour objectif d’informer les
          utilisateurs du site <strong>hlbk.fr</strong> des modalités de collecte,
          d’utilisation et de protection de leurs données personnelles, conformément
          au Règlement Général sur la Protection des Données (RGPD).
        </p>
      </article>

      <article className="legal-card">
        <h2>2 — Responsable du traitement</h2>
        <p>
          Les données personnelles collectées sur le site sont traitées par :
        </p>
        <p>
          <strong>HLBK — Photographe</strong>
          <br />
          Tomblaine (54510), France
          <br />
          Email : <a href="mailto:contact@hlbk.fr">contact@hlbk.fr</a>
          <br />
          Téléphone : <a href="tel:+33663252202">+33 6 63 25 22 02</a>
        </p>
      </article>

      <article className="legal-card">
        <h2>3 — Données collectées</h2>
        <p>Les données personnelles susceptibles d’être collectées sont notamment :</p>
        <ul>
          <li>Nom et prénom</li>
          <li>Adresse email</li>
          <li>Numéro de téléphone</li>
          <li>Contenu des messages envoyés via le formulaire de contact</li>
          <li>Données de navigation anonymisées (mesure d’audience)</li>
        </ul>
        <p>Aucune donnée sensible n’est collectée volontairement.</p>
      </article>

      <article className="legal-card">
        <h2>4 — Finalités du traitement</h2>
        <p>Les données collectées sont utilisées uniquement pour :</p>
        <ul>
          <li>Répondre aux demandes envoyées via le formulaire de contact</li>
          <li>Établir des devis et assurer le suivi client</li>
          <li>Améliorer l’expérience utilisateur et les performances du site</li>
          <li>Mesurer l’audience du site (statistiques)</li>
        </ul>
      </article>

      <article className="legal-card">
        <h2>5 — Base légale</h2>
        <p>Le traitement des données repose sur :</p>
        <ul>
          <li>Le consentement de l’utilisateur</li>
          <li>L’exécution de mesures précontractuelles ou d’un contrat</li>
          <li>L’intérêt légitime (amélioration du site, sécurité)</li>
        </ul>
      </article>

      <article className="legal-card">
        <h2>6 — Durée de conservation</h2>
        <p>
          Les données personnelles sont conservées pendant la durée nécessaire au
          traitement de la demande, puis au maximum <strong>3 ans</strong> après le
          dernier contact, sauf obligation légale contraire.
        </p>
      </article>

      <article className="legal-card">
        <h2>7 — Destinataires des données</h2>
        <p>
          Les données collectées sont strictement destinées à <strong>HLBK</strong>.
          Elles ne sont <strong>ni vendues, ni louées, ni transmises</strong> à des tiers.
        </p>
        <p>
          Certains prestataires techniques (hébergement, outils de mesure d’audience)
          peuvent traiter des données de manière indirecte et sécurisée, uniquement
          pour permettre le fonctionnement du site.
        </p>
      </article>

      <article className="legal-card">
        <h2>8 — Cookies et mesure d’audience</h2>
        <p>Le site peut utiliser :</p>
        <ul>
          <li>Des cookies techniques nécessaires à son bon fonctionnement</li>
          <li>Des cookies de mesure d’audience (statistiques)</li>
        </ul>
        <p>Aucun cookie publicitaire n’est utilisé intentionnellement.</p>
        <p>
          Vous pouvez configurer votre navigateur pour refuser ou limiter l’utilisation des cookies.
        </p>
      </article>

      <article className="legal-card">
        <h2>9 — Sécurité</h2>
        <p>
          HLBK met en œuvre les mesures techniques et organisationnelles raisonnables
          pour assurer la sécurité et la confidentialité des données personnelles.
        </p>
      </article>

      <article className="legal-card">
        <h2>10 — Droits des utilisateurs</h2>
        <p>Conformément au RGPD, vous disposez notamment des droits suivants :</p>
        <ul>
          <li>Droit d’accès</li>
          <li>Droit de rectification</li>
          <li>Droit d’effacement</li>
          <li>Droit d’opposition</li>
          <li>Droit à la limitation du traitement</li>
        </ul>
        <p>
          Pour exercer vos droits, vous pouvez contacter :
          <br />
          <a href="mailto:contact@hlbk.fr">contact@hlbk.fr</a>
        </p>
      </article>

      <article className="legal-card">
        <h2>11 — Modification de la politique</h2>
        <p>
          La présente politique de confidentialité peut être modifiée à tout moment.
          La version en vigueur est celle publiée sur le site.
        </p>
        <p className="legal-note">Dernière mise à jour : janvier 2026</p>
      </article>
    </section>
  );
}